<template>
	<v-app class="auth-layout-wrapper">
		<v-alert
			v-if="isShowAlert"
			absolute
			:type="alertType || 'success'"
			transition="scale-transition"
			class="app-alert"
			:dismissible="false"
		>
			{{ alertMessage }}

			<v-icon style="font-size: 20px" @click="closeAlert"> mdi-window-close </v-icon>
		</v-alert>

		<AppTopBar v-bind:menuList="menuList" />

		<v-main class="v-main_container">
			<v-container
				:fluid="shouldBeFullWidth"
				:class="shouldBeFullWidth ? '' : 'auth-container'"
			>
				<ChatNotification
					v-if="notifications.length > 0 && shouldShowNotification"
					:showChatNotification="showChatNotification"
					:notifications="notifications"
					@closeChatNotification="handleClose"
				/>
				<PostReportNotification :showNotification.sync="showNotification" />
				<v-row
					:class="{ column__wrapper: true, 'column__wrapper-playerOn': currentPodcast }"
				>
					<v-col
						v-if="shouldShowSidebar"
						:md="3"
						class="column__left pa-0"
						style="max-width: 250px; width: 250px"
					>
						<AppSidebar :menuListHandler="menuListHandler" />
						<div v-if="shouldLeftBannerShow" class="mt-3">
							<AdBanner />
						</div>
					</v-col>
					<v-col
						:md="6"
						class="column__middle pa-0"
						:class="shouldBeFullWidth ? 'ma-0' : ''"
					>
						<slot></slot>
					</v-col>
					<v-col
						v-if="shouldRightBannerShow && !shouldBeFullWidth"
						:lg="3"
						class="column__right pa-0"
						style="max-width: 250px"
					>
						<AdBanner v-if="shouldShowSidebar" />
					</v-col>
				</v-row>
			</v-container>
			<Transition name="player">
				<AppPlayer v-if="currentPodcast" />
			</Transition>
		</v-main>
	</v-app>
</template>
<script>
import { isUndefined } from 'lodash'
import AppSidebar from '@/components/Layouts/parts/AppSidebar'
import AppTopBar from '@/components/Layouts/parts/AppTopBar'
import AppPlayer from '@/components/Layouts/parts/AppPlayer'
import ChatNotification from '@/components/Notifications/ChatNotification'
import PostReportNotification from '@/components/Notifications/PostReportNotification'
import { mapActions, mapGetters } from 'vuex'
import AdBanner from '@/components/Layouts/parts/AdBanner.vue'

export default {
	components: {
		AdBanner,
		AppTopBar,
		AppSidebar,
		AppPlayer,
		ChatNotification,
		PostReportNotification,
	},
	data: () => ({
		navCategory: null,
		showNotification: false,
		showChatNotification: false,
		accentColor: '#9b1045',
		menuList: [],
		notifications: [],
	}),
	watch: {
		isAuthenticated(val, oldVal) {
			if (isUndefined(oldVal)) return
			if (!val) this.$router.replace('/auth')
		},
	},
	methods: {
		...mapActions('app', ['hideAlert']),

		closeAlert() {
			clearTimeout(this.closeTimeout)
			this.hideAlert()
		},

		handleClose() {
			this.notifications = []
			this.showChatNotification = false
		},
		menuListHandler(menu) {
			this.menuList = menu
		},
	},
	computed: {
		...mapGetters('auth', ['profile']),
		...mapGetters('settings', ['web']),
		...mapGetters('app', ['isShowAlert', 'alertMessage', 'closeTimeout', 'alertType']),
		...mapGetters('rss', ['currentPodcast']),

		user() {
			return this.profile
		},
		shouldShowNotification() {
			return this.$route.name !== 'chat' && this.$route.name !== 'chats'
		},
		shouldShowSidebar() {
			return this.$route.meta.sidebar && this.$vuetify.breakpoint.width >= 920
		},
		shouldBeFullWidth() {
			return this.$route.meta.fullWidth
		},
		shouldRightBannerShow() {
			if (!this.web) {
				return false
			}
			return (
				!!this.web.banner_image &&
				this.$vuetify.breakpoint.lgAndUp &&
				this.$vuetify.breakpoint.width >= 1160
			)
		},
		shouldLeftBannerShow() {
			if (!this.web) {
				return false
			}
			const width = this.$vuetify.breakpoint.width
			return width >= 1024 && width < 1160
		},
		leftSideBarMd() {
			return this.shouldRightBannerShow ? 3 : 4
		},
	},
	destroyed() {
		this.$eventBus.$off('show-report-notification')

		if (this.user) {
			window.Echo.leave('App.User.' + this.profile.id)
		}
	},
}
</script>

<style lang="scss">
.auth-container {
	max-width: 1160px !important;
}

.v-main_container {
	background: #f1f1f1;
}

@media screen and (max-width: 1400px) {
	.auth-container {
		max-width: 1160px !important;
	}
}

.column {
	&__wrapper {
		padding-top: 30px;
		justify-content: center;

		@media (max-width: 920px) {
			padding-top: 12px;
		}

		&-playerOn {
			margin-bottom: 100px;

			@media (max-width: 710px) {
				margin-bottom: 150px;
			}

			@media (max-width: 530px) {
				margin-bottom: 200px;
			}
		}
	}

	&__middle {
		max-width: 600px;
		margin: 0 30px;
		flex-grow: 1;

		@media (max-width: 1159px) {
			margin-right: 0;
		}
		@media (max-width: 920px) {
			margin: 0 16px;
		}
		@media (max-width: 616px) {
			max-width: calc(100% - 32px);
		}
	}
}

.app-alert {
	top: 20px;
	right: 20px;
	position: fixed;
	z-index: 2;
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
	opacity: 0;
}

.player-enter-active,
.player-leave-active {
	transition: transform 0.3s;
}

.player-enter,
.player-leave-to {
	transform: translateY(100px);
}
</style>
